import { Button, Box, FormControl, Input, InputLabel, TableHead, Stack, Table, TablePagination, Typography, Select, MenuItem, Grid, Tabs, Tab } from '@mui/material'
import React, { useCallback, useRef, useEffect, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ActionsBar from '../../../components/ActionsBar';
import { Download, FilterAlt } from '@mui/icons-material'
import TextField from '@mui/material/TextField/TextField';
import Paper from '@mui/material/Paper'
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import CourseItem from './components/CourseItem';
import { styled } from '@mui/material/styles'
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { authAtom, shopsAtom, staffsAtom, tokenAtom } from '../../../actions';
import { useAtom, useAtomValue } from 'jotai';
import axios from 'axios';
import dayjs from 'dayjs';
import DateRangeModal from '../Payments/modals/DateRangeModal';
import AddComissionModal from '../Leads/modals/AddComissionModal';
import { toast } from 'react-toastify';
import { hasPermission, showConfirmationToast, convertMoney, getOrderId, LEAD_ORDER_STATUS, LEAD_ORDER_PAYMENT_STATUS } from '../../../utils/utils';
import * as XLSX from 'xlsx'
import { MultiSelect } from "react-multi-select-component";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        zIndex: 1
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const CourseList = () => {
    const [orders, setOrders] = useState([])
    const [token] = useAtom(tokenAtom)
    const [total, setTotal] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(50)
    const [page, setPage] = useState(0)
    const [dateRangeModal, setDateRangeModal] = useState(false)
    const [startDate, setStartDate] = useState(dayjs().subtract(90, 'days').format())
    const [endDate, setEndDate] = useState(dayjs().format())
    const [shop, setShop] = useState(0)
    const [keyword, setKeyword] = useState('');
    const [status, setStatus] = useState('missed')
    const staffs = useAtomValue(staffsAtom)
    const [selectedStaffs, setSelectedStaffs] = useState([])
    const authUser = useAtomValue(authAtom)
    const toastId = useRef(null)
    const timeoutRef = useRef(null);
    const [debouncedKeyword, setDebouncedKeyword] = useState('');
    const [tabValue, setTabValue] = useState(0);
    const [expiringCourses, setExpiringCourses] = useState([])

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setDebouncedKeyword(keyword);
        }, 500);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [keyword]);

    const onChangeRange = (range) => {
        setStartDate(range.startDate)
        setEndDate(range.endDate)
        setDateRangeModal(false)
    }

    const refreshOrder = useCallback(() => {
        console.log({ token })
        if (token) {
            axios.defaults.headers.common['Authorization'] = `Token ${token}`

            const endpoint = tabValue === 0 ? '/booking/lead_order/all_courses/' : '/booking/lead_order/expiring_courses/';

            axios.post(endpoint, {
                offset: page * rowsPerPage,
                limit: rowsPerPage,
                shop: shop > 0 ? shop : null,
                staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                status: status,
                from_date: dayjs(startDate).startOf('day').format(), to_date: dayjs(endDate).endOf('day').format(),
                keyword: debouncedKeyword.replace(/#/g, '')
            })
                .then((response) => {
                    if (response && response.data) {
                        if (tabValue === 0) {
                            setOrders(response.data.orders)
                        } else {
                            setExpiringCourses(response.data.orders)
                        }
                        setTotal(response.data.total)
                    }
                })
                .catch((error) => {
                    console.log({ error })
                })
        }

    }, [token, page, rowsPerPage, startDate, endDate, selectedStaffs, debouncedKeyword, shop, status, tabValue])

    useEffect(() => {
        refreshOrder()
    }, [refreshOrder])

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeKeyword = (e) => {
        setPage(0)
        setKeyword(e.target.value)
    }

    const onDownload = () => {
        const title = tabValue === 0 ? 'Lieu trinh' : 'liệu trình sắp hết';
        showConfirmationToast(`Chắc chắn tải về danh sách ${title} từ ${dayjs(startDate).format('DD/MM/YYYY')} đến ${dayjs(endDate).format('DD/MM/YYYY')}?`,
            () => {
                setTimeout(() => {
                    toastId.current = toast.loading("Đang tải dữ liệu")
                    const endpoint = tabValue === 0 ? '/booking/lead_order/download_all_courses/' : '/booking/lead_order/download_expiring_courses/';
                    
                    axios.post(endpoint, {
                        shop: shop > 0 ? shop : null,
                        staffs: selectedStaffs.length > 0 ? selectedStaffs.map((item) => item.value) : null,
                        status: status,
                        from_date: dayjs(startDate).startOf('day').format(), to_date: dayjs(endDate).endOf('day').format(),
                        keyword: debouncedKeyword.replace(/#/g, '')
                    })
                        .then((response) => {
                            try {
                                if (response && response.data) {
                                    const report = response.data.map((item) => {

                                        return ({
                                            'order': getOrderId(item.id),
                                            'date': dayjs(item.order_date).format('HH:mm:ss DD/MM/YYYY'),
                                            'full_name': item.user.full_name,
                                            'username': item.user.username,
                                            'service': item?.serviceName ?? item?.service?.name,
                                            'price': item.price,
                                            'completed_booking': item.completed_booking,
                                            'number_of_booking': item.number_of_booking,
                                            'support_user': item.support_user?.full_name ?? '',
                                            'sale1': item.sale1?.full_name ?? '',
                                            'sale2': item.sale2?.full_name ?? '',
                                            'telesale': item.telesale?.full_name ?? '',
                                        })
                                    })
                                    const worksheet = XLSX.utils.json_to_sheet(report, { origin: 'A2' });
                                    const headers = ['Mã liệu trình', 'Ngày mua', "Khách hàng", 'Số điện thoại', 'Liệu trình', 'Giá trị', 'Số buổi đã hoàn thành', 'Tổng số buổi', 'Nhân viên đặt', 'Sale 1', 'Sale 2', 'Telesale']
                                    worksheet['!merges'] = [
                                        { s: { r: 0, c: 0 }, e: { r: 0, c: headers.length } },
                                    ]
                                    XLSX.utils.sheet_add_aoa(worksheet, [[`Danh sách ${title} từ ${dayjs(startDate).format('DD/MM/YYYY')} đến ${dayjs(endDate).format('DD/MM/YYYY')}`]], { origin: "A1" });
                                    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A2" });
                                    const workbook = XLSX.utils.book_new();
                                    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet 1');
                                    XLSX.writeFile(workbook, `Danh sách ${title}.xlsx`);

                                    toast.dismiss(toastId.current)
                                    toast.success('Tải về thành công')
                                }
                            } catch (error) {
                                console.log({ error })
                                toast.dismiss(toastId.current)
                                toast.error('Lỗi tải về')
                            }
                        })
                        .catch((error) => {
                            console.log({ error })
                            toast.dismiss(toastId.current)
                            toast.error('Lỗi tải về')
                        })
                }, 500);
            }, () => { })
    }

    const staffOptions = staffs.map((item) => ({ label: item.full_name, value: item.id }))
    // staffOptions.unshift({ label: 'Tất cả', id: 0 })

    if (!(authUser && hasPermission(authUser, ['view_order', 'view_order_all', 'view_course_expiring']))) {
        return <Stack sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', margin: '32px' }}>Không có quyền truy cập</Stack>
    }

    return (
        <Box style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
            <ActionsBar title='Danh sách liệu trình' subTitle={`Tìm thấy ${total} đơn hàng`} />
            
            <Tabs value={tabValue} onChange={handleTabChange} sx={{ mb: 2, px: 3 }}>
                <Tab label="Danh sách liệu trình" />
                <Tab label="Danh sách liệu trình sắp hết" />
            </Tabs>

            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', marginLeft: '24px', marginRight: '24px' }}>
                <Box sx={{ flexDirection: 'row', display: 'flex', gap: '16px', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                    <Grid container spacing={2} sx={{zIndex: 5}}>
                        <Grid item xs={6} md={3}>
                            <FormControl sx={{ width: '100%' }} variant='standard'>
                                <InputLabel sx={{ fontSize: '12px' }}>Tên khách hàng, số điện thoại</InputLabel>
                                <Input
                                    value={keyword} onChange={handleChangeKeyword}
                                    size='small' style={{ width: '100%' }}
                                    placeholder="Tên khách hàng, số điện thoại"
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <Stack gap={'16px'} sx={{ alignItems: 'flex-end', width: '100%' }}>
                                <Stack gap={'8px'} direction='row' sx={{ flexWrap: 'wrap', width: '100%', justifyContent: { xs: 'center', md: 'flex-end' } }}>
                                    <Stack sx={{ width: '100%', cursor: 'pointer', borderBottom: '0.5px solid #cccccc', padding: '6px 0px', borderRadius: '5px' }} variant='standard' onClick={() => setDateRangeModal(true)}>
                                        <InputLabel sx={{ fontSize: '10px' }}>Thời gian</InputLabel>
                                        <Typography sx={{ fontSize: '12px' }}>{`${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`}</Typography>
                                    </Stack>
                                </Stack>
                            </Stack>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            <FormControl sx={{ width: '100%' }} variant='standard'>
                                <InputLabel sx={{ fontSize: '12px' }}>Đã gắn đơn?</InputLabel>
                                <Select sx={{ fontSize: '12px' }}
                                    defaultValue={null} value={status}
                                    onChange={(e) => setStatus(e.target.value)} label='Đã gắn đơn?'>
                                    {
                                        [
                                            { label: 'Tất cả', id: 'all' },
                                            { label: 'Chưa gắn đơn', id: 'missed' },
                                            { label: 'Đã gắn đơn', id: 'attached' },
                                        ].map((item) => {
                                            return (
                                                <MenuItem value={item.id}>{item.label}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} md={3}>
                            {
                                hasPermission(authUser, ['view_order_all']) && (
                                    <Stack sx={{ zIndex: 20, fontSize: '12px' }}>
                                        <MultiSelect
                                            options={staffOptions}
                                            value={selectedStaffs}
                                            onChange={setSelectedStaffs}
                                            labelledBy="Chọn nhân viên"
                                            overrideStrings={{
                                                "allItemsAreSelected": "Tất cả",
                                                "clearSearch": "Xoá",
                                                "clearSelected": "Bỏ chọn",
                                                "search": "Tìm kiếm",
                                                "selectAll": "Chọn tất cả",
                                                "selectAllFiltered": "Chọn tất cả",
                                                "selectSomeItems": "Lựa chọn nhân viên"
                                            }}
                                        />
                                    </Stack>
                                )
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <Box style={{ display: "flex", width: '100%', marginTop: '24px', padding: '0px' }}>
                <Paper style={{ padding: '0px', width: '100%' }}>
                    <Stack direction='row' justifyContent='flex-end' spacing='16px'>
                        <TablePagination
                            rowsPerPageOptions={[20, 30, 40, 50]}
                            component="div"
                            count={total}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                        {hasPermission(authUser, ['export_report_order']) && <Button onClick={onDownload}><Download /></Button>}
                    </Stack>
                    <TableContainer component={Paper} style={{ overflowY: 'scroll', width: '100%', overflowX: 'scroll', maxHeight: '60vh' }}>
                        <Table stickyHeader>
                            <TableHead sx={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                                <TableRow>
                                    <StyledTableCell style={{ minWidth: '60px' }}>Mã liệu trình</StyledTableCell>
                                    <StyledTableCell style={{ minWidth: '80px' }}>Ngày mua</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '120px' }}>Khách hàng</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '120px' }}>Liệu trình</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '80px' }}>Đơn hàng</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '120px' }}>Giá trị</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '120px' }}>Số buổi đã dùng</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '80px' }}>Tổng số buổi</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '80px' }}>NV Đặt</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '80px' }}>Sale 1</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '80px' }}>Sale 2</StyledTableCell>
                                    <StyledTableCell align="right" style={{ minWidth: '80px' }}>Telesale</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tabValue === 0 ? orders.map((order, index) => (
                                    <CourseItem order={order} key={`${index}-${order.id.toString()}`} />
                                )) : expiringCourses.map((order, index) => (
                                    <CourseItem order={order} key={`${index}-${order.id.toString()}`} />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Box>

            <DateRangeModal
                open={dateRangeModal}
                startDate={startDate}
                endDate={endDate}
                onConfirm={onChangeRange}
                handleClose={() => {
                    setDateRangeModal(false)
                }}
            />
        </Box>
    )
}

export default CourseList